@if (loaded) {
  <panel>
    <div class="row">
      <div class="col-12">
        <div class="panel-section">
          <h1>{{ 'sale.register-sale' | translate }}</h1>
        </div>
        <div class="panel-section">
          <div class="row">
            <div class="col-12">
              <span class="out-of-focus">{{ 'sale.product-filter' | translate }}</span>
            </div>
          </div>
          <div class="row button-row">
            @for (filter of filters; track filter) {
              <div class="col">
                <div class="button action" [ngClass]="{ active: (selectedFilter === filter) }" (click)="selectFilter(filter)">
                  {{ filter.tag }}
                </div>
              </div>
            }
          </div>
        </div>
        @if (selectedFilter) {
          <div class="panel-section">
            <div class="row">
              @for (product of products; track product) {
                @if (verifyProductCredentials(product) && productSelectedByFilter(product)) {
                  <div class="col-4">
                    <div class="product">
                      <h3 title="{{ product.name }}" class="no-overflow">{{product.name}}</h3>
                      @for (variantList of variantLists; track variantList) {
                        @if (!missingRequiredProduct(product) && showVariantList(variantList, product)) {
                          <div>
                            <div class="header4">{{ variantList.name }}</div>
                            @for (variantListOption of variantList.variantListOptions; track variantListOption) {
                              @if (variantListOptionUsedByProduct(variantListOption, product)) {
                                <div class="button header3 variant-list-option" [ngClass]="{ active: variantListOptionSelected(variantListOption) && activeProduct === product }" (click)="selectVariant(product, variantListOption)">
                                  {{ variantListOption.name }}
                                </div>
                              }
                            }
                          </div>
                        }
                      }
                      @if (product.productVariants.length === 1 && !missingRequiredProduct(product)) {
                        <div class="header4">{{ 'sale.no-variants' | translate }}</div>
                        <div class="button header3 variant-list-option" [ngClass]="{ active: activeProduct === product }" (click)="selectVariant(product)">
                          {{ 'general.select' | translate }}
                        </div>
                      }
                      @if (selectedVariant != null && activeProduct != null && activeProduct === product) {
                        <div>
                          <div class="row">
                            <div class="col-6">
                              @if (selectedVariantPeriod > 0) {
                                <div>
                                  <custom-input [label]="'sale.price-per-month' | translate" [class]="'header3'" [value]="monthPrice" (valueChange)="updatePrice($event, 'month')" [inputType]="inputType.Currency" />
                                </div>
                              }
                            </div>
                            <div class="col-6">
                              <div class="text-right">
                                <custom-input [label]="'sale.total-price' | translate" [class]="'header3'" [value]="price" (valueChange)="updatePrice($event, 'total')" textAlign="right" [inputType]="inputType.Currency" />
                              </div>
                              <div class="out-of-focus text-right">{{ 'sale.discount' | translate }} {{discount}}%</div>
                            </div>
                            @if (activeProduct.groupByVariantAndParentOnOrder) {
                              <div class="col-2 quantity">{{ 'sale.quantity' | translate }}</div>
                              <div class="col-4">
                                <custom-select [selectList]="quantityList" [(value)]="quantitySelectedAsString" />
                              </div>
                            }
                            <div [ngClass]="activeProduct.groupByVariantAndParentOnOrder ? 'col-6' : 'col-12'">
                              @if (pickingParentProduct) {
                                <div class="button green">{{ 'sale.pick-product-in-basket' | translate }}</div>
                              }
                              @if (!pickingParentProduct) {
                                <div class="button green" (click)="addVariantToOrder()">{{ 'general.add' | translate }}</div>
                              }
                            </div>
                          </div>
                        </div>
                      }
                      @if (missingRequiredProduct(product)) {
                        <div class="row">
                          <div class="col-1"><icon type="square-info" class="info-icon" /></div>
                          <div class="col">{{ 'editsale.missing-required-product' | translate: { 'requiredProduct.name': product.requiredProduct?.name ?? '' } }}</div>
                        </div>
                      }
                    </div>
                  </div>
                }
              }
            </div>
          </div>
        }
      </div>
    </div>
  </panel>
}
@if (loaded) {
  <panel width="400">
    <div class="row">
      <div class="col-12">
        <div class="panel-section">
          <h1>{{ 'sale.basket-header' | translate }}</h1>
        </div>
        <div class="panel-section">
          <div class="row">
            <div class="col-12" #basket (document:mousedown)="clickedOutside($event.target)">
              <ul class="bullet-list no-gutters">
                @if (parentOrderLines.length > 0) {
                  <ng-container *ngTemplateOutlet="basketProductsTemplate; context:{ $implicit: parentOrderLines, className: 'parent' }" />
                }
                @if (parentCompanyProducts.length > 0) {
                  <ng-container *ngTemplateOutlet="companyProductsTemplate; context:{ $implicit: parentCompanyProducts, className: 'parent' }" />
                }
              </ul>
              @if (displayEmptyBasket()) {
                <div class="shopping-cart">
                  <icon type="shopping-cart" />
                </div>
              }
              <div class="total-amount">{{ orderLineTotal | currency }}</div>
            </div>
            <div class="col-12">
              <!-- fix new Order before enabling <file-upload [label]="'sale.upload-contract' | translate"
              [(busy)]="uploading"
              [uploadedFiles]="uploadedFiles"
              accept=".msg,.jpg,.pdf"
              [maxFiles]="1"
              [uploadUrl]="'/api/upload/create-sale-attachments/order/' + orderId"
            removeUrl="/api/upload/remove-sale-attachment"></file-upload>-->
          </div>
          <div class="col-12">
            <date-input [label]="'sale.sign-date' | translate" [(value)]="signDate" />
          </div>
          @for (agreement of saleAgreements; track agreement; let i = $index) {
            <div class="col-12">
              <label (click)="showSaleAgreement(agreement)">
                <span class="fas fa-file-signature input-related"></span> {{ agreement.title }}
              </label>
              <input class="checkbox switch float-right" id="{{ agreement.id }}" type="checkbox" [checked]="selectedAgreement == agreement" (click)="selectSpecialAgreement(agreement)" />
            </div>
          }
          <div class="col-12">
            <!--<submit-button #createSaleButton [ignoreValidation]="true" [active]="enableSubmit" (click)="createSale()" [label]="'sale.create-sale' | translate" />-->
          </div>
        </div>
      </div>
    </div>
  </div>
</panel>
}

<ng-template #basketProductsTemplate let-products let-class="className">
  @for (product of products; track product) {
    <li [class]="class" [ngClass]="{ selectable: selectableParent(product) }" (click)="clickedOrderLine(product)">
      <menu>
        <menuitem (click)="removeOrderLineFromOrder(product)" icon="trash">{{ 'general.delete' | translate }}</menuitem>
      </menu>
      <div class="product-name">{{ productService.getVariantName(product.productVariant) }}</div>
      <div class="text-right">{{ product.totalPrice | currency }}</div>
    </li>
    @if (product.childLines.length > 0) {
      <ng-container *ngTemplateOutlet="basketProductsTemplate; context:{ $implicit: product.childLines, className: 'child' }" />
    }
  }
</ng-template>

<ng-template #companyProductsTemplate let-products let-class="className">
  @for (product of products; track product) {
    @if (displayCompanyProduct(product)) {
      <li [class]="'company-products ' + class" [ngClass]="{ selectable: selectableParent(product) }" (click)="clickedOrderLine(product)">
        <div class="product-name">{{ 'sale.existing-product' | translate: { 'variant.name': productService.getVariantName(product.productVariant) } }}</div>
      </li>
    }
    @if (!product.id) {
      <li [class]="class" [ngClass]="{ selectable: selectableParent(product) }" (click)="clickedOrderLine(product)">
        <menu>
          <menuitem (click)="removeOrderLineFromOrder(product)" icon="trash">{{ 'general.delete' | translate }}</menuitem>
        </menu>
        <div class="product-name">{{ productService.getVariantName(product.productVariant) }}</div>
        <div class="text-right">{{ product.totalPrice | currency }}</div>
      </li>
    }
    @if (product.childLines.length > 0) {
      <ng-container *ngTemplateOutlet="companyProductsTemplate; context:{ $implicit: product.childLines, className: 'company-products child' }" />
    }
  }
</ng-template>
